import script from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./AppFooter.vue?vue&type=custom&index=0&blockType=svg&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&class=icon%20icon-tabler%20icon-tabler-brand-telegram&width=24&height=24&viewBox=0%200%2024%2024&stroke-width=2&stroke=currentColor&fill=none&stroke-linecap=round&stroke-linejoin=round"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__